import React from "react";
import TaskNotificationList from "../component/TaskNotificationList";

const TaskNotificationListContainer = () => (<TaskNotificationList />)

export default TaskNotificationListContainer;
